import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_TOS_LEGAL_NOTICE_BANNER = createFcmDetails('tos_legal_notice_banner', {
	owner: 'Site Platform',
	context: 'Terms of Service legal/policy banner',
	description: `
			Displays a banner notifying users of a change in Terms of Service.

			- effectiveDate: the date the new ToS are effective - should be a ISO-formatted datetime (https://en.wikipedia.org/wiki/ISO_8601) - examples: "2022-10-08T12:00:00Z" (UTC) or "2022-10-08T12:00:00+08:00" (+08:00 TZ)
			- preEffectiveRange: number of days before the effective date, where the pre-effective banner should be displayed (usually 7 - set to 0 to disable pre-effective banner)
			- postEffectiveRange: number of days after the effective date, where the pre-effective banner should be displayed (usually up to 60)
			- maxDisplayCount: max number of times the banner should be displayed - applies separately to pre and post banners and is reset for any other subsequent ToS change

			Related to tos_legal_notice_banner_copy FCM
		`,
	template: {
		effectiveDate: '2022-10-08T12:00:00Z',
		preEffectiveRange: 7,
		postEffectiveRange: 60,
		maxDisplayCount: 3,
	},
	import: false,
});
